import { ParsedUserRole, UserCommunity, UserRole } from '@interfaces/auth';
import { SelectableCommunity } from '@vibTheme/components/_base/Input/CommunitiesSelectionModal';

/**
 * O recorte por PAPEL e a conversão para linha do seletor, num lugar só.
 *
 * Os dois campos de comunidade — `InputCommunities`, do painel, e `InputProduct`, dos relatórios —
 * mostram a mesma lista com o mesmo rótulo, e por muito tempo tiveram uma cópia cada um. Divergiram:
 * a #366 corrigiu o rótulo de colaboração no primeiro e o segundo continuou dizendo "Afiliado" por
 * mais quatro meses, em onze telas (#376).
 *
 * O papel sai do BALDE, e é o ponto de partir de `UserCommunity`: o balde de colaboração chega da
 * API com `userRole: 'AFFILIATED'` porque o `UserRole` de lá só tem os quatro papéis de comissão, e
 * ler aquele campo é o que produz o defeito. Quem já resolveu isso é o `formatCommunities` do
 * `GroupsContext`; estas funções consomem a resposta dele e não o campo cru.
 */
export const filtrarComunidadesPorPapel = (
  communities: UserCommunity[],
  userRoles: UserRole[],
): UserCommunity[] =>
  communities.filter((community) =>
    community.userRoles.some((papel) => userRoles.includes(papel)),
  );

/**
 * A linha do seletor.
 *
 * Os papéis vão TODOS, e não o primeiro: quem é afiliada e também colaboradora da mesma comunidade
 * tem duas coisas verdadeiras para dizer, e escolher uma esconde a outra.
 */
export const paraComunidadesSelecionaveis = (
  communities: UserCommunity[],
): SelectableCommunity[] =>
  communities.map((community) => ({
    id: community.id,
    name: community.name,
    active: community.active,
    userRoleLabel: community.userRoles
      .map((papel) => ParsedUserRole[papel])
      .join(', '),
  }));
